var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Autocomplete__Wrapper" },
    [
      _c(
        "MaterialInput",
        _vm._b(
          {
            staticClass: "city-form-group city-bg",
            attrs: {
              type: "text",
              id: "input-code",
              name: "code",
              id: _vm.mdInputId,
              name: _vm.mdInputName,
              maxlength: _vm.mdInputMaxlength,
              placeholder: _vm.$t(_vm.mdInputPlaceholder),
            },
            on: {
              focus: function ($event) {
                $event.stopPropagation()
                return _vm.openOnFocus.apply(null, arguments)
              },
              blur: _vm.hideOptions,
              input: _vm.onInput,
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.openOnFocus.apply(null, arguments)
              },
            },
            model: {
              value: _vm.searchTerm,
              callback: function ($$v) {
                _vm.searchTerm = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "searchTerm",
            },
          },
          "MaterialInput",
          _vm.$attrs,
          false
        ),
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }